import * as _ from 'lodash';
import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {ShipmentDriver, ShipmentDriverJSON} from './shipment-driver';
import {ShipmentRoute} from './shipment-route';
import {AuthService, BaseService} from '@hassel-it/angular-common';
import {HttpClient} from '@angular/common/http';
import {Shipment, ShipmentJSON} from "./shipment";

@Injectable()
export class ShipmentDriversService extends BaseService {

    constructor(public http: HttpClient, public authService: AuthService) {
        super(http, authService);
    }

    getShipmentDrivers(): Promise<ShipmentDriver[]> {
        this.reloadHeaders();
        return this.http.get(environment.apiBase + '/api/ten-four/shipment_drivers', {
            headers: this.httpHeaders
        }).toPromise().then((response: any) => {
            return _.chain(response.data).map((json: ShipmentDriverJSON): ShipmentDriver => {
                return ShipmentDriver.fromJSON(json)
            }).value();
        }).catch(ShipmentDriversService.handleError);
    }


    getShipmentDriver(shipmentDriverId: string): Promise<ShipmentDriver> {
        return this.http.get(environment.apiBase + '/api/ten-four/shipment_drivers/' + shipmentDriverId, {
            headers: this.httpHeaders
        }).toPromise().then((response: any) => {
            return ShipmentDriver.fromJSON(response.data);
        }).catch(ShipmentDriversService.handleError);
    }

    getShipmentDriverStatus(shipmentDriverId: string): Promise<any> {
        return this.http.get(environment.apiBase + '/api/ten-four/shipment_drivers/' + shipmentDriverId + '/status', {
            headers: this.httpHeaders
        }).toPromise().then((response: any) => {

            const results = response.data.map((json: ShipmentJSON): Shipment => {
                return Shipment.fromJSON(json)
            });

            return {data: results, driver: response.driver, route: response.route};
        }).catch(ShipmentDriversService.handleError);
    }



    addShipmentDriver(shipmentDriver: ShipmentDriver): Promise<ShipmentDriver> {
        this.reloadHeaders();

        return this.http.post(environment.apiBase + '/api/ten-four/shipment_drivers', shipmentDriver, {
            headers: this.httpHeaders
        }).toPromise().then((response: any) => {
            return response.data as ShipmentDriver;
        }).catch(ShipmentDriversService.handleError);
    }

    updateShipmentDriver(shipmentDriver: ShipmentDriver): Promise<ShipmentDriver> {
        this.reloadHeaders();

        return this.http.patch(environment.apiBase + '/api/ten-four/shipment_drivers/' + shipmentDriver.id, shipmentDriver, {
            headers: this.httpHeaders
        }).toPromise().then((response: any) => {
            return response.data as ShipmentDriver;
        }).catch(ShipmentDriversService.handleError);
    }

    deleteShipmentDriver(shipmentDriver: ShipmentDriver): Promise<boolean> {
        this.reloadHeaders();

        return this.http.delete(environment.apiBase + '/api/ten-four/shipment_drivers/' + shipmentDriver.id, {
            headers: this.httpHeaders
        }).toPromise().then((response: any) => {
            return true;
        }).catch(ShipmentDriversService.handleError);
    }
}
